export const windowBreakpoint = window.breakpoint;
